var CONFUSEDCMS = CONFUSEDCMS || {},
    CONFUSEDPARKINGAPP = CONFUSEDPARKINGAPP || {};
    CONFUSEDPARKINGAPP.Filter = CONFUSEDPARKINGAPP.Filter || {};

(function (ns, $) {
    'use strict';

    // filter constants
    ns.FilterConstants = {
        AllocatedSpace: 'allocated_space',
        ShelteredParking: 'sheltered_parking',
        Garage: 'lockup_or_garage',
        TwentyFourSevenAccess: 'twentyfour_hours_access',
        SecurityGates: 'security_gates',
        AirportTransfers: 'arranged_transfer'
    };

    // handle filter
    ns.handleFilter = function (parkingFilter, parkingSpaces) {

        // loop spaces
        $.each(parkingSpaces, function (index, space) {

            // apply filters
            if (ns.isSpacesAvailableFiltered(parkingFilter, space) ||
                ns.isShortLongTermFiltered(parkingFilter, space) ||
                ns.isFeaturesFiltered(parkingFilter, space)) {
                space.Enabled(false);
            }
            else {
                space.Enabled(true);
            }
        });

        return parkingSpaces;
    };

    // is spaces available filtered
    ns.isSpacesAvailableFiltered = function (parkingFilter, space) {
        if (parkingFilter.SpacesAvailable() === true && space.SpacesAvailable() === false) {
            return true;
        }
        return false;
    };

    // is short or long term filtered
    ns.isShortLongTermFiltered = function (parkingFilter, space) {
        if ((parkingFilter.ShortTerm() === true && (space.PriceHourly() > 0 || space.PriceDaily() > 0)) ||
            (parkingFilter.LongTerm() === true && space.PriceMonthly() > 0)) {
            return false;
        }
        return true;
    };

    // is features filtered
    ns.isFeaturesFiltered = function (parkingFilter, space) {
        if (ns.isFeatureFiltered(parkingFilter.AllocatedSpace(), space.Features(), ns.FilterConstants.AllocatedSpace) ||
            ns.isFeatureFiltered(parkingFilter.ShelteredParking(), space.Features(), ns.FilterConstants.ShelteredParking) ||
            ns.isGarageFiltered(parkingFilter.Garage(), space.SpaceType()) ||
            ns.isFeatureFiltered(parkingFilter.TwentyFourSevenAccess(), space.Features(), ns.FilterConstants.TwentyFourSevenAccess) ||
            ns.isFeatureFiltered(parkingFilter.SecurityGates(), space.Features(), ns.FilterConstants.SecurityGates) ||
            ns.isFeatureFiltered(parkingFilter.AirportTransfers(), space.Features(), ns.FilterConstants.AirportTransfers)) {
            return true;
        }
        return false;
    };

    // is feature filtered
    ns.isFeatureFiltered = function (filterFeature, spaceFeatures, feature) {
        if (filterFeature === true) {
            var isFeatureFiltered = true;
            $.each(spaceFeatures, function (index, spaceFeature) {
                if (spaceFeature === feature) {
                    isFeatureFiltered = false;
                }
            });
            return isFeatureFiltered;
        }
        return false;
    };

    // is garage filtered
    ns.isGarageFiltered = function (filterGarage, spaceType) {
        if (filterGarage === true && spaceType !== ns.FilterConstants.Garage) {
            return true;
        }
        return false;
    };

}(CONFUSEDPARKINGAPP.Filter, jQuery));